import React from "react";
import "./map-embed.scss";

const MapEmbed = ({ name = "", address, websites }) => {
  if (!websites || !websites.length) {
    return <></>;
  }

  const mapsObject = websites.filter(
    (site) => site.type === "GoogleMapsLink"
  )[0];

  if (!mapsObject || !mapsObject.url) {
    return <></>;
  }

  const mapUrl =
    "https://www.google.com/maps/embed/v1/place?q=" +
    encodeURI(address.replace("&", "")) +
    "&key=AIzaSyD1dvnAGbU_ulBomWGucoXFUlLESVOD_e0";

  if (!mapUrl || mapUrl === "") {
    return <></>;
  }

  return (
    <div id="map-embed">
      <iframe
        src={mapUrl}
        title={`${name} Map`}
        frameBorder="0"
        allowFullScreen
      ></iframe>
    </div>
  );
};
export default MapEmbed;
